const CAROUSEL_DATA = [
  {
    title: '暑期娱乐圈大盘点',
    desc: '这个夏天最劲爆的娱乐新闻都在这里，多位明星动态持续追踪，不容错过的精彩回顾。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20collage%20with%20warm%20lighting%2C%20red%20carpet%20theme%2C%20cinematic%20atmosphere%2C%20spotlights%20and%20glamorous%20vibe%2C%20abstract%20composition%2C%20no%20faces%2C%20no%20text%2C%20dark%20rich%20background%20with%20golden%20highlights%2C%20editorial%20photography%20style&width=800&height=500&seq=carousel-1-2026&orientation=landscape',
    tag: '专题策划',
  },
  {
    title: '顶流明星合约风波',
    desc: '近期多起明星合约纠纷引发关注，深度解析背后的商业逻辑与行业规则。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20on%20empty%20stage%20with%20contract%20documents%20silhouette%2C%20warm%20amber%20theater%20lighting%2C%20mysterious%20atmosphere%2C%20dark%20velvet%20background%2C%20cinematic%20composition%2C%20high%20contrast%2C%20editorial%20style%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-2-2026&orientation=landscape',
    tag: '深度追踪',
  },
  {
    title: '热播综艺幕后揭秘',
    desc: '带你走进热门综艺节目录制现场，了解不为人知的幕后故事与制作细节。',
    img: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20warm%20production%20lights%2C%20professional%20camera%20equipment%20silhouette%2C%20dramatic%20backlighting%2C%20cinematic%20atmosphere%2C%20dark%20background%20with%20glowing%20warm%20accents%2C%20editorial%20photography%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-3-2026&orientation=landscape',
    tag: '独家揭秘',
  },
  {
    title: '新晋流量小花崛起之路',
    desc: '从默默无闻到万众瞩目，新一代娱乐明星的成长轨迹与爆红密码。',
    img: 'https://readdy.ai/api/search-image?query=Glamorous%20spotlight%20rising%20from%20darkness%2C%20dramatic%20stage%20lighting%20with%20warm%20golden%20beams%2C%20elegant%20atmosphere%2C%20red%20carpet%20texture%2C%20cinematic%20composition%2C%20luxurious%20dark%20background%2C%20editorial%20style%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-4-2026&orientation=landscape',
    tag: '人物特写',
  },
  {
    title: '音乐盛典全记录',
    desc: '年度音乐颁奖典礼精彩瞬间回顾，谁是最耀眼的舞台王者？',
    img: 'https://readdy.ai/api/search-image?query=Music%20awards%20ceremony%20stage%20with%20dramatic%20lighting%2C%20golden%20trophy%20silhouette%2C%20confetti%20and%20sparkles%2C%20warm%20atmospheric%20lighting%2C%20cinematic%20vibe%2C%20dark%20elegant%20background%2C%20editorial%20photography%2C%20no%20text%2C%20no%20recognizable%20people&width=800&height=500&seq=carousel-5-2026&orientation=landscape',
    tag: '盛典回顾',
  },
  {
    title: '年度绯闻谣言大盘点',
    desc: '那些年在娱乐圈引起轩然大波的传闻，真相究竟如何？一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20silhouette%20behind%20frosted%20glass%20with%20warm%20glow%2C%20dramatic%20shadows%2C%20news%20headlines%20abstract%20collage%2C%20dark%20moody%20atmosphere%2C%20cinematic%20mystery%20vibe%2C%20editorial%20photography%2C%20no%20text%2C%20no%20recognizable%20faces&width=800&height=500&seq=carousel-6-2026&orientation=landscape',
    tag: '真相还原',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-focus-2-line text-accent-500 mr-2"></i>焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">深度策划 · 多维呈现 · 吃瓜必备</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAROUSEL_DATA.map((item, idx) => (
            <article
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx < 3 ? 'eager' : 'lazy'}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-accent-500/90 text-white text-xs font-bold">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}